import { useHead } from '@unhead/react';
import { useTranslation } from 'translations/hooks';

import { SingleCardPageWithFilterCardLayout } from 'business/layout/single-card-page-with-filter-card';
import { ProdAndPerfFilters } from 'business/production-and-performance/components/prod-and-perf-filters';
import { RingsTableWithPagination } from 'business/production-and-performance/pages/ring-table/components/ring-table-with-pagination';
import { MobileRingTable } from 'business/production-and-performance/pages/ring-table/mobile';
import { ProdAndPerfFiltersProvider } from 'business/production-and-performance/providers/prod-and-perf-filters-provider';
import { useFilterData } from 'technical/filter-data';
import { useMediaType } from 'technical/media/hooks';
import { CustomFilterCard } from 'ui/filter-card';
import { SelectedItemsFooter } from 'ui/filter-footer';
import { DateSelectionTypeEnum } from 'ui/form/temporality-select-input';

import { RingTableHeader } from './components/ring-table-header';

export interface RingTableFilterData {
  selectedRings?: number;
}

export const RingTablePage = () => {
  const { t } = useTranslation();

  const { filterData, setFilterData } = useFilterData<RingTableFilterData>();

  useHead({ title: t('user.menu.sections.prodPerf.ringList.title') });

  const { isMobile } = useMediaType();

  if (isMobile) {
    return <MobileRingTable />;
  }

  return (
    <ProdAndPerfFiltersProvider
      initialFilters={{
        filterType: 'date',
        dateRange: [null, null],
        // dayMode is not used for RingTable but required in the type by design
        dayMode: 'shift',
      }}
      noDefaultFor={[DateSelectionTypeEnum.Period]}
    >
      <SingleCardPageWithFilterCardLayout
        title={t('productionAndPerformance.ring.title')}
        filters={
          <CustomFilterCard
            footer={
              filterData?.selectedRings ? (
                <SelectedItemsFooter>
                  {t('productionAndPerformance.ring.selectedRings', {
                    selectedRings: filterData?.selectedRings,
                  })}
                </SelectedItemsFooter>
              ) : null
            }
          >
            <ProdAndPerfFilters noDefaultFor={[DateSelectionTypeEnum.Period]} />
          </CustomFilterCard>
        }
        header={<RingTableHeader />}
      >
        <RingsTableWithPagination setFilterData={setFilterData} />
      </SingleCardPageWithFilterCardLayout>
    </ProdAndPerfFiltersProvider>
  );
};

export default RingTablePage;
